import labels from "emun.customer/_labels";
import basicController from "servicestack/basic.controller.properties";
import orderConfig from "emun.order/order.config";
import CustomerDashboardController from 'emun.customer/customer-dashboard.controller';

export default class CustomerDashboardHeaderController extends CustomerDashboardController {
  constructor() {
    super();
    const $ctrl = this;
    basicController($ctrl);
    $ctrl.orderConfig = orderConfig;
    $ctrl.labels = labels;
  }
}
